// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","tags":"DocumentTags_tags__38NoQ","divider":"DocumentTags_divider__2v-By"};